import bootstrapImage from "../images/bootstrap.png";
import cSharpImage from "../images/csharp.png";
import cssImage from "../images/css.png";
import firebaseImage from "../images/firebase.svg";
import htmlImage from "../images/html.png";
import javaImage from "../images/java.svg";
import jsImage from "../images/js.png";
import mysqlImage from "../images/mysql.svg";
import nodejsImage from "../images/nodejs.svg";
import oracleImage from "../images/oracle.png";
import pythonImage from "../images/python.svg";
import sqlServerImage from "../images/sqlserver.svg";
import pyridam from "../images/pyridam.jpg";
import awi from "../images/awi.jpg";
import flutter from "../images/flutter.png";
import poltek from "../images/image.png";
import sma2 from "../images/sma2.jpg";
import marketResearch from "../images/marketReseach.jpg";
import Minesweeper from "../images/minesweeper.png";
import LRlogin from "../images/LRlogin.png";

import alpine from "../images/Alpine.png";
import ODOL from "../images/ODOL.png";
import wosa from "../images/wosa.png";
import helmet from "../images/helmet.png";
import toolmaintenance from "../images/toolmaintenance.png";
import webFilm from "../images/websitefilm.png";
import freelance from "../images/freelance.png";
import newArmada from "../images/newArmada.png";
import ciroyomA from "../images/CiroyomA.png";
import ciroyomB from "../images/CiroyomB.png";
import ciroyomC from "../images/CiroyomC.png";
import ciroyomD from "../images/CiroyomD.png";
import ciroyomE from "../images/CiroyomE.png";
import ciroyomF from "../images/CiroyomF.png";
import thesisA from "../images/thesisA.png";
import thesisB from "../images/thesisB.png";
import thesisC from "../images/ThesisC.png";
import thesisD from "../images/ThesisD.png";
import thesisE from "../images/ThesisE.jpg";
import rekrutA from "../images/rekrutA.jpg";
import rekrutB from "../images/rekrutB.jpg";
import rekrutC from "../images/rekrutC.jpg";
import rekrutD from "../images/rekrutD.jpg";
import foodA from "../images/foodA.jpg";
import foodB from "../images/foodB.jpg";
import kmsA from "../images/kmsA.png";
import kmsB from "../images/kmsB.png";
import kmsC from "../images/kmsC.png";
import kmsD from "../images/kmsD.png";
import kmsE from "../images/kmsE.png";
import kmsF from "../images/kmsF.png";

import motor from "../images/motor.png";
import odolB from "../images/odolB.png";
import odolC from "../images/odolC.png";
import odolD from "../images/odolD.png";
import odolF from "../images/odolF.png";
import odolE from "../images/odolE.png";
import toolB from "../images/toolB.png";
import toolC from "../images/toolC.jpg";
import lurichB from "../images/lurichB.png";
import lurichC from "../images/lurichC.png";
import lurichD from "../images/lurichD.png";

import asean from "../images/asean.png";
import aseanC from "../images/aseanC.png";
import aseanB from "../images/aseanB.png";
import cryptoA from "../images/cryptoA.png";
import cryptoB from "../images/cryptoB.png";
import cryptoC from "../images/cryptoC.png";
import bullA from "../images/bullA.png";
import bullB from "../images/bullB.png";
import rupiah from "../images/rupiah.png";
import rupiahB from "../images/rupiahB.png";
import rupiahC from "../images/rupiahC.png";

import c from "../images/c.png";
import php from "../images/php.png";
import ci from "../images/ci.png";
import tail from "../images/tail.png";
import laravel from "../images/laravel.png";
import rs from "../images/rs.png";
import rsB from "../images/rsB.png";
import rsC from "../images/rsC.png";
import dynamic from "../images/dynamic.jpeg";
import sap from "../images/sap.png";
import azure from "../images/azure.jpeg";

import dashA from "../images/dashA.jpg";
import dashB from "../images/dashB.jpg";
import dashC from "../images/dashC.jpg";
import dashD from "../images/dashD.jpg";
import libA from "../images/libA.png";
import libB from "../images/libB.png";

import libC from "../images/libC.png";
import libD from "../images/libD.png";
import libE from "../images/libE.png";
import plnA from "../images/plnA.png";
import plnB from "../images/plnB.png";
import plnC from "../images/plnC.png";
import plnD from "../images/plnD.png";

import apsn from "../images/apsn.png";
import apsnB from "../images/apsnB.png";
import apsnC from "../images/apsnC.png";
import apsnD from "../images/apsnD.png";
import motorB from "../images/motorB.png";

import presenceA from "../images/presenceA.png";
import presenceB from "../images/presenceB.png";
import presenceC from "../images/presenceC.png";
import presenceD from "../images/presenceD.png";
import presenceE from "../images/presenceE.png";
import presenceF from "../images/presenceF.png";
import presenceG from "../images/presenceG.png";
import presenceH from "../images/presenceH.png";

import diktiA from "../images/diktiA.png";
import diktiB from "../images/diktiB.png";
import diktiC from "../images/diktiC.png";
import diktiD from "../images/diktiD.png";

import invenA from "../images/invenA.png";
import invenB from "../images/invenB.png";
import invenC from "../images/invenC.png";
import invenD from "../images/invenD.png";

import streamA from "../images/streamA.png";
import streamB from "../images/streamB.png";
import streamC from "../images/streamC.png";
import streamD from "../images/streamD.png";

import pharmaA from "../images/pharmaA.png";
import pharmaB from "../images/pharmaB.png";
import pharmaC from "../images/pharmaC.png";
import pharmaD from "../images/pharmaD.png";

import financeA from "../images/financeA.png";
import financeB from "../images/financeB.png";
import financeC from "../images/financeC.png";
import financeD from "../images/financeD.png";

import dailyA from "../images/dailyA.png";
import dailyB from "../images/dailyB.png";
import dailyC from "../images/dailyC.png";
import dailyD from "../images/dailyD.png";
import dailyE from "../images/dailyE.png";

import inventA from "../images/inventA.png";
import inventB from "../images/inventB.png";
import inventC from "../images/inventC.png";
import inventD from "../images/inventD.png";

import diesA from "../images/diesA.png";
import diesB from "../images/diesB.png";
import diesC from "../images/diesC.png";
import diesD from "../images/diesD.png";
import diesE from "../images/diesE.png";

import preventiveA from "../images/preventiveA.png";
import preventiveB from "../images/preventiveB.png";
import preventiveC from "../images/preventiveC.png";

import ppsA from "../images/ppsA.png";
import ppsB from "../images/ppsB.jpg";
import ppsC from "../images/ppsC.jpg";
import ppsD from "../images/ppsD.jpg";

import toolsA from "../images/toolsA.png";
import toolsB from "../images/toolsB.png";
import toolsC from "../images/toolsC.png";
import carWashA from "../images/carWashA.jpeg";
import restaurantA from "../images/restaurantA.jpeg";
import churchA from "../images/churchA.jpeg";
import hotelA from "../images/hotelA.jpeg";

export const Bio = {
  name: "Christoper Richard",
  roles: [
    "Web Developer",
    "Android Developer",
    "System Analyst",
    "Market Researcher",
  ],
  description:
    " Professional Software Developer with a passion for solving complex problems and creating scalable digital solutions. Experienced in full-stack development for Web, Mobile, and Desktop applications using modern technologies. Skilled in optimizing performance and enhancing user experience. With a growth mindset and adaptability to emerging trends, I excel in collaborating with international teams to build impactful software solutions",
  // "Always give the best and deliver beyond expectations",

  github: "https://github.com/",
  resume:
    "https://drive.google.com/file/d/1fsfE390sBgA6Igr-S9Re5u42lLX08J07/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/christoperrichardsantoso/",
  twitter: "https://twitter.com/",
  insta: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: htmlImage,
      },
      {
        name: "Vanilla CSS",
        image: cssImage,
      },
      {
        name: "JavaScript",
        image: jsImage,
      },
      {
        name: "Bootstrap",
        image: bootstrapImage,
      },
      {
        name: "Tailwind",
        image: tail,
      },
      {
        name: "Alpine JS",
        image: alpine,
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: nodejsImage,
      },
      {
        name: "Python",
        image: pythonImage,
      },
      {
        name: "PHP",
        image: php,
      },
      {
        name: "Laravel",
        image: laravel,
      },
      {
        name: "CodeIgnitor",
        image: ci,
      },
      {
        name: "Java",
        image: javaImage,
      },
      {
        name: "Java Android",
        image: javaImage,
      },
      {
        name: "Flutter",
        image: flutter,
      },
      {
        name: "C# & ASP. Net",
        image: cSharpImage,
      },
      {
        name: "C",
        image: c,
      },
    ],
  },
  {
    title: "Database",
    skills: [
      {
        name: "Oracle",
        image: oracleImage,
      },

      {
        name: "MySQL",
        image: mysqlImage,
      },
      {
        name: "Microsoft SQL Server",
        image: sqlServerImage,
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "SAP Analytics Cloud",
        image: sap,
      },
      {
        name: "Firebase",
        image: firebaseImage,
      },
      {
        name: "Microsoft 365 Dynamic ERP",
        image: dynamic,
      },

      {
        name: "Market Research",
        image: sqlServerImage,
      },
      {
        name: "Microsoft Azure Fundamental",
        image: azure,
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: newArmada,
    role: "IT Staff Tooling Division",
    company: "PT Mekar Armada Jaya (New Armada)",
    date: "Sept 2024 - Present",
    desc: `
    - Developed Tooling Information System, collaborated with other department to connected and synchronice data.

    - Digitalization manual  document process, interating with AI Assistant to help end-user

    - Build Daily Report, connected with Social Media to give notification and information`,

    skills: [
      "PHP",
      "MySql",
      "CodeIgnitor 3",
      "CodeIgnitor 4",
      "Redis",
      "GSAP",
      "Javascript",
    ],
    // doc: "",
  },
  {
    id: 1,
    img: freelance,
    role: "Software Developer",
    company: "Freelance",
    date: "May 2024 - Present",
    desc: `
    - Successfully developed a document management scheme website for the village administration, increasing work efficiency by 14.3%.
    
    - Successfully created a clinic website that includes doctor schedules and medical services.
    
    - Created an application for a final project campus, which included data management, activity tracking, and data summary features.`,
    skills: ["PHP", "MySql", "CodeIgnitor 3", "Javascript", "HTML", "CSS"],
    // doc: "",
  },
  {
    id: 2,
    img: awi,
    role: "IT Developer (Intern & Outsourcing)",
    company: "PT Akashi Wahana Indonesia",
    date: "Nov 2023 - Sept 2024",
    desc: `
    - Development of Knowledge Management System PT Akashi Wahana Indonesia encompassing a submission system, approval system, digital learning platform, training assessments, and training evaluation mechanisms.
    
    - Enhancement of the visual interface of the internal company website.
    
    - Establishment of a corporate employment application website.`,
    skills: [
      "PHP",
      "SQL Server",
      "CodeIgnitor 3",
      "Oracle",
      "Javascript",
      "HTML",
      "CSS",
    ],
    // doc: "",
  },
  {
    id: 3,
    img: marketResearch,
    role: "Market Researcher",
    company: "Individu",
    date: "Nov 2021 - Present",
    desc: `Have of experience in market research, specializing in cryptocurrencies, US stocks, and Indonesia stocks. My expertise includes analyzing movement of global liquidity money and execute trade in market trends.`,
    skills: ["Analysist", "Technical Analysist", "Fundamental Analysist"],
  },
  {
    id: 4,
    img: pyridam,
    role: "Data Entry (Freelance)",
    company: "PT Pyridam Farma",
    date: "May 2021 - August 2021",
    desc: `Proficient in managing performance data calculations for 30 employees
    - Experienced in converting documents from paper format to Excel and Word format
    - Skilled in creating data management templates in Excel, resulting in a 30-40% increase in data management efficiency.`,
    skills: [
      "Microsoft Excel",
      "Microsoft Word",
      "Microsoft Power Point",
      "Microsoft Visio",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: poltek,
    school: "Politeknik Astra, Cikarang (Astra Group)",
    date: "Sep 2021 - Sep 2024",
    grade: "3.66 GPA",
    desc: "Selected as one of the recipients from 6,835 applicants for the Astra Bina Ilmu Scholarship",
    degree: "Informatics Management",
  },
  {
    id: 1,
    img: sma2,
    school: "SMAN 2 Surabaya",
    date: "Jul 2018 - Jun 2021",
    grade: "93.2",
    desc: "",
    degree: "Science",
  },
];

export const projects = [
  {
    id: 20,
    title: "Tools Inventory System",
    date: "Jan 2025",
    description:
      "This web-based application is designed to manage and monitor the availability, condition, and usage history of tools. It streamlines the inventory process by enabling staff to check in/check out tools, view tool specifications, and track usage logs through a centralized dashboard.\n\n" +
      "The system includes a notification feature that automatically sends email alerts when tool stock levels fall below a defined threshold",
    image: toolsA,
    images: [toolsA, toolB, toolC],
    tags: [
      "PHP",
      "Laravel",
      "MySQL",
      "Email Notification",
      "GSAP",
      "Particle JS",
    ],
    category: "web app",
  },
  {
    id: 19,
    title: "Preventice Maintenance & Repair Problem",
    date: "Jan 2025",
    description:
      "This web-based platform is designed to streamline and digitize the process of preventive maintenance and repair problem. It's also use for scheduling maintenanace, manage history maintenance and analysist problem. The platform includes centralized storage and version control, ensuring easy access, traceability, and data consistency across departments.",
    image: preventiveA,
    images: [preventiveA, preventiveB, preventiveC],
    tags: ["Laravel", "MySQL", "Bootstrap"],
    category: "web app",
  },
  {
    id: 18,
    title: "Dies Information System",
    date: "Jan 2025",
    description:
      "This system centralizes data management for dies used in production processes. It allows users to record detailed information such as die specifications, usage logs, maintenance history, lifespan tracking, and storage location. This digitized system improves traceability and ensures that each die's operational status is always updated and accessible to relevant stakeholders",
    image: diesA,
    images: [dailyA, dailyB, dailyC, dailyD, dailyE],
    tags: [
      "Laravel",
      "MySQL",
      // "AI Integration",
      "Redis",
      "GSAP",
      "Particle JS",
      // "SAP Integration",
    ],
    category: "web app",
  },
  {
    id: 17,
    title: "Digitalization Document Process",
    date: "Jan 2025",
    description:
      "This web-based platform is designed to streamline and digitize the process of creating and managing PPS DCP (Daily Control Point) and CCP JCP (Job Control Point) reports within an organization. It replaces manual reporting with structured digital templates, enabling employees to submit reports more efficiently while reducing administrative overhead. The platform includes centralized storage and version control, ensuring easy access, traceability, and data consistency across departments. \n\n" +
      "Powered by the Gemini API, the system leverages AI capabilities to analyze submitted reports and provide valuable insights on employee performance.",
    image: ppsA,
    images: [ppsA, ppsB, ppsC, ppsD],
    tags: ["PHP", "CI4", "MySQL", "AI Integration"],
    category: "web app",
  },
  {
    id: 16,
    title: "Daily Report",
    date: "Jan 2025",
    description:
      "A web-based system for employees to submit daily activity reports, which are then compiled for managerial review. Integrated with WhatsApp API for reminder notifications and Gemini API for auto-summarizing report content",
    image: dailyA,
    images: [dailyA, dailyB, dailyC, dailyD, dailyE],
    tags: ["PHP", "CI4", "MySQL", "Whatsapp Notification", "AI Integration"],
    category: "web app",
  },
  {
    id: 15,
    title: "Presence Manager",
    date: "Jan 2025",
    description:
      "The Presence Manager platform enables employees to track their attendance and manage leave requests. It supports location-based absence tracking, allowing employees to mark their presence even when working remotely or from different offices. This web platform enhances productivity by automating attendance management, reducing scheduling conflicts, and give analytics of employee attendance.",
    image: presenceA,
    images: [
      presenceA,
      presenceB,
      presenceC,
      presenceD,
      presenceE,
      presenceF,
      presenceG,
      presenceH,
    ],
    tags: ["PHP", "Laravel", "Tailwind", "MySQL", "Flutter"],
    category: "web app",
  },
  {
    id: 14,
    title: "DSAKTI Website",
    date: "Nov 2024",
    description:
      "The LLDIKTI is a platform designed to facilitate easy access to manage information about universities within the LLDIKTI region. The platform includes a searchable list of universities, along with detailed profiles that cover accreditation status, available programs, campus facilities, and key faculty. This web platform provides users to get informed about the latest developments in the higher education sector.",
    image: diktiA,
    images: [diktiA, diktiB, diktiC, diktiD],
    tags: ["PHP", , "AlpineJS", "MySQL"],
    category: "web app",
  },
  {
    id: 13,
    title: "APSN Website",
    date: "Oct 2024",
    description:
      "The APSN website is a platform for facilitates document creation, document approvals, correspondence, event scheduling, and article publication. It streamlines workflows by enabling up to 30% faster document management, efficient communication, reducing scheduling conflicts by 17% through organized scheduling features, and increasing collaborative article sharing, all of which enhance overall productivity and teamwork",
    image: apsn,
    images: [apsn, apsnB, apsnC, apsnD],
    tags: ["PHP", "Laravel", "CSS", "Javascript", "HTML", "MySQL"],
    category: "web app",
  },
  {
    id: 12,
    title: "Thesis Hub",
    date: "Sept 2024",
    description:
      "Application for a final project campus, which included data management, activity tracking, and data summary features",
    image: thesisA,
    images: [thesisA, thesisB, thesisC, thesisD, thesisE],
    tags: ["PHP", "CI3", "CSS", "Javascript", "HTML", "SQL SERVER"],
    category: "web app",
  },
  {
    id: 11,
    title: "Village Administration",
    date: "August 2023",
    description:
      "Developed a village administration website to streamline and processing document requests for residents. This website include email notification, total report approval/reject, limitations login(By NIK in that area)",
    image: ciroyomA,
    images: [
      ciroyomA,
      ciroyomB,
      ciroyomE,
      ciroyomC,
      ciroyomD,
      ciroyomE,
      ciroyomF,
    ],
    tags: ["PHP", "CI3", "CSS", "Javascript", "HTML", "SQL SERVER"],
    category: "web app",
  },
  {
    id: 10,
    title: "Monitoring and Maintenance of Substation Equipment",
    date: "Sept 2024",
    description:
      "The Monitoring and Maintenance of Substation Equipment system is designed to ensure the reliability and performance of substation assets through real-time monitoring and proactive maintenance. This system enables tracking equipment health, scheduling preventive maintenance, and quickly identifying issues, enhancing the overall stability and efficiency of power distribution.",
    image: plnA,
    images: [plnA, plnB, plnC, plnD],
    tags: ["PHP Laravel", "CSS", "Javascript", "HTML", "SQL SERVER"],
    category: "web app",
  },

  {
    id: 9,
    title: "Clinic Website",
    date: "July 2024",
    description:
      "a clinic website that includes doctor schedules and medical services",
    image: rs,
    images: [rs, rsB, rsC],
    tags: ["PHP Laravel", "CSS", "Javascript", "HTML", "MySQL"],
    category: "web app",
  },
  {
    id: 8,
    title: "Landing Library",
    date: "June 2024",
    description:
      "The Landing Library is a web-based learning platform I developed for practicing Laravel. It serves as a resource hub where users can explore books, manage collections, and practice CRUD operations, all within a Laravel-based environment designed for learning and experimentation.",
    image: libA,
    images: [libA, libB, libC, libD, libE],
    tags: ["PHP Laravel", "CSS", "Javascript", "HTML", "MySQL"],
    category: "web app",
  },

  {
    id: 7,
    title: "Dashboard Monitoring and Report for Finance",
    date: "Sept 2024",
    description:
      "The Dashboard Monitoring and Report for Finance is a web-based platform for streamlined financial oversight and reporting. This platform enables user for analysyzing financial reports. It features multiple dashboards for various financial indicators and category. The program empowers finance teams to make informed decisions quickly and efficiently.",
    // image: dashA,
    // images: [
    //     dashA,
    //     dashB,
    //     dashC,
    //     dashD,
    //     // Tambahkan lebih banyak URL gambar sesuai kebutuhan
    // ],
    image: motorB,
    images: [
      motorB,
      // Tambahkan lebih banyak URL gambar sesuai kebutuhan
    ],
    tags: ["PHP", "CI3", "CSS", "Javascript", "HTML", "Oracle"],
    category: "web app",
  },
  {
    id: 6,
    title: "Recruitment and Evaluation Development Program",
    date: "August 2023 - Sept 2024",
    description:
      "The Recruitment and Evaluation Development Program is a web-based platform designed to manage the employee recruitment and candidate evaluation process. Featuring 9 flow of selection, 20 master data sets, and 16 detailed components. This platform has the advantage of flexibility in setting recruitment criteria.",
    image: rekrutA,
    images: [
      rekrutA,
      rekrutB,
      rekrutC,
      rekrutD,
      // Tambahkan lebih banyak URL gambar sesuai kebutuhan
    ],
    tags: ["PHP", "CI3", "CSS", "Javascript", "HTML", "SQL Server", "Oracle"],
    category: "web app",
  },
  {
    id: 5,
    title: "Food and Snack Order",
    date: "July 2024",
    description:
      "Web-based platform designed to simplify the ordering process for meals and snacks. It allows users to browse menus, place orders, and requirement date. This system also included approval process, daily order limit and daily meal and snack schedule needed. The platform aims to streamline order management and optimize the overall food ordering process.",
    image: foodA,
    images: [foodA, foodB],
    tags: ["PHP", "CI3", "CSS", "Javascript", "HTML", "SQL SERVER"],
    category: "web app",
  },
  {
    id: 4,
    title: "Knowledge Management System",
    date: "Jan 2024 - May 2024",
    description:
      "The Knowledge Management System (KMS) is a platform designed to enhance organizational learning and knowledge sharing. It features a submission and approval system, an e-learning module that offers video-based learning and study modules, and a training test (exam system). The system also includes a learning progress tracker to monitor participant development and evaluation participant.",
    image: kmsA,
    images: [kmsA, kmsB, kmsC, kmsD, kmsE, kmsF],
    tags: ["PHP", "CI3", "CSS", "Javascript", "HTML", "SQL SERVER"],
    category: "web app",
  },
  {
    id: 3,
    title: "Movie Website",
    date: "Jan 2024",
    description:
      "A Movie Website is an online platform designed to offer users access to a wide range of movie-related content. This Web using API for getting list of movie",
    image: webFilm,
    images: [webFilm],
    tags: ["React Js", "API", "HTML", "CSS", "Javascript"],
    category: "web app",
  },
  {
    id: 2,
    title: "Maintain Motorcycle",
    date: "Oct 2023 - Dec 2023",
    description:
      "Web application for maintain and management data and enhance productivity in the workplace. It provides specific motorb1ike management, technical data, and motorbike document management",
    image: motor,
    images: [motor, motorB],
    tags: ["Java", "HTML", "CSS", "Javascript", "Oracle"],
    category: "web app",
  },
  {
    id: 1,
    title: "Tool Maintenance",
    date: "Jun 2023 - Jul 2023",
    description:
      "Developed an integrated Android application and website to efficiently manage repair schedules. The application handles reminders, form submissions, and tool tracking, while the website is used for mastering data tools and parts.",
    image: toolmaintenance,
    images: [toolmaintenance, toolB, toolC],
    tags: [
      "Java Android",
      "Java Springboot",
      "Firebase",
      "HTML",
      "CSS",
      "Javascript",
      "SQL Server",
    ],
    category: "android app",
  },
  {
    id: 1,
    title: "Employee Performance Assessment",
    date: "Jan 2023 - Feb 2023",
    description:
      "Developed an application for calculating employee work efficiency using predetermined metrics and calculations.",
    image: wosa,
    images: [wosa],
    tags: ["PHP CI3", "MySQL", "HTML", "CSS", "Javascript"],
    category: "web app",
  },
  {
    id: 2,
    title: "One Dasboard One Link",
    date: "Jan 2023 - Feb 2023",
    description:
      "Integrated application between campuses, companies and internship students in recording daily activities, evaluating performance and assessing student internships.",
    image: ODOL,
    images: [
      ODOL,
      odolB,
      odolC,
      odolD,
      odolD,
      odolE,
      odolF,
      // Tambahkan lebih banyak URL gambar sesuai kebutuhan
    ],
    tags: ["ASP. Net", "C#", "SQL Server", "HTML", "CSS", "Javascript"],
    category: "web app",
  },
  {
    id: 3,
    title: "Helmet Detector",
    date: "Oct 2022 - Jan 2023",
    description:
      "Develop an application designed to detect the presence of safety helmets within work areas, ensuring compliance with safety regulations and enhancing workplace safety measures.",
    image: helmet,
    images: [
      helmet,
      // Tambahkan lebih banyak URL gambar sesuai kebutuhan
    ],
    tags: [
      "Phyton",
      "Java Android",
      "PHP",
      "MySQL",
      "HTML",
      "CSS",
      "Javascript",
      "XML",
      "Visual Paradigm",
    ],
    category: "android app",
  },
  {
    id: 15,
    title: "Lurich Hotel",
    date: "May 2022 - Jun 2022",
    description:
      "Developed an application to process room data, manage room transactions and record financial reports.",
    image: LRlogin,
    images: [LRlogin, lurichB, lurichC, lurichD],
    tags: ["C#", "SQL Server", "HTML", "CSS", "Javascript"],
    category: "android app",
  },
  {
    id: 4,
    title: "Minesweeper",
    date: " Apr 2022 - May 2022",
    description:
      "Developed a user-friendly Minesweeper game application with various difficulty levels and a leaderboard feature to track and display high scores.",
    image: Minesweeper,
    images: [Minesweeper],
    tags: ["C#", "SQL Server", "HTML", "CSS", "Javascript"],
    category: "android app",
  },

  {
    id: 16,
    title: "Rupiah Movement Prediction",
    date: "March 2024",
    description:
      "(Preview Only) Selling Module for analysis and forecast of the Indonesian Rupiah's exchange rate fluctuations against other currencies. It involves evaluating factors such as domestic economic indicators (inflation, interest rates, GDP growth), global market conditions, political stability, and external factors like commodity prices and trade balances. The prediction aims to provide insights into potential currency movements and risks in the foreign exchange market. ",
    image: rupiah,
    images: [
      rupiah,
      rupiahB,
      rupiahC,
      // Tambahkan lebih banyak URL gambar sesuai kebutuhan
    ],
    tags: ["Rupiah", "Macro Economic", "Technical Analysis"],
    category: "machine learning",
  },
  {
    id: 17,
    title: "ASEAN Economic Outlook",
    date: "Feb 2024",
    description:
      "(Preview Only) Selling Module fo analysis of the ASEAN Economic Outlook. The ASEAN Economic Outlook provides an analysis of the economic landscape of the Association of Southeast Asian Nations (ASEAN). It highlights key trends, growth opportunities, and challenges faced by the region's member states. ",
    image: asean,
    images: [
      asean,
      aseanB,
      aseanC,
      // Tambahkan lebih banyak URL gambar sesuai kebutuhan
    ],
    tags: ["ASEAN", "Macro Economic"],
    category: "machine learning",
  },
  {
    id: 17,
    title: "Crypto Outlook Q1 2024",
    date: "Feb 2024",
    description:
      "(Preview Only) Selling Module for analysis of the Crypto Outlook Q1 2024. The Crypto Outlook Q1 2024 provides analysis of the cryptocurrency market for the first quarter of the year. It explores key trends, regulatory developments, and technological innovations expected to shape the crypto space. The report focuses on major cryptocurrencies like Bitcoin, Ethereum, and emerging altcoins and analyzing price movements. Additionally, it highlights factors such as institutional adoption, the impact of global economic conditions, and advancements in blockchain technology. The outlook also discusses potential risks and opportunities for investors, predicting how the crypto market could evolve in response to these dynamics. ",
    image: cryptoA,
    images: [cryptoA, cryptoB, cryptoC],
    tags: ["Crypto", "Macro Economic"],
    category: "machine learning",
  },
  {
    id: 18,
    title: "Bull Momentum 2023",
    date: "Oct 2023",
    description:
      "(Preview Only) Selling Module fo analysis of the Reversal of the Financial Market 2023. This module contain some reason for the reversal of the financial market. It is based on the macroeconomic analysis. ",
    image: bullA,
    images: [bullA, bullB],
    tags: ["ASEAN", "Macro Economic"],
    category: "machine learning",
  },
];
export const skillUp = [
  {
    id: 8,
    title: "Church Profile",
    // date: "Jan 2023 - Feb 2023",
    description: "A comprehensive digital platform for modern ministries",
    image: churchA,
    images: [churchA],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://church-pro.netlify.app/",
  },
  {
    id: 7,
    title: "Hotel Management System",
    // date: "Jan 2023 - Feb 2023",
    description:
      "A premium hospitality booking engine. This application offers a seamless reservation experience, featuring real-time room availability, interactive galleries, and a sleek UI that reflects the luxury of the stay.",
    image: hotelA,
    images: [hotelA],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://hotel-destination.netlify.app/",
  },
  {
    id: 6,
    title: "Restaurant Management System",
    // date: "Jan 2023 - Feb 2023",
    description:
      "An immersive culinary web experience. It features dynamic menu browsing with high-resolution visuals, an integrated table reservation system, and a mobile-first design for hungry customers on the go",
    image: restaurantA,
    images: [restaurantA],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://restaurants-culinary.netlify.app/",
  },
  {
    id: 5,
    title: "Car Wash",
    // date: "Jan 2023 - Feb 2023",
    description:
      "A streamlined service management app for automotive care. Users can book detailing slots, choose service packages, and track their car's status through a clean, efficient, and user-friendly interface",
    image: carWashA,
    images: [carWashA],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://car-wash-pro.netlify.app/",
  },
  {
    id: 4,
    title: "Online Medicine Store",
    // date: "Jan 2023 - Feb 2023",
    description:
      "CareFirst Pharmacy is a full-featured e-commerce web application for a pharmacy business. It allows users to browse products, filter by categories, view ratings and prices, add to cart, place orders, and track deliveries. Designed with a modern UI for a seamless user experience.",
    image: pharmaA,
    images: [pharmaA, pharmaB, pharmaC, pharmaD],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://care-first-pharmacy.netlify.app/",
  },
  {
    id: 3,
    title: "Personal Finance Management App",
    // date: "Oct 2022 - Jan 2023",
    description:
      "Personal Finance is a web application designed to help users manage their income, expenses, and investments with a clear and intuitive dashboard. The app features financial reporting, budget planning, and tax calculation tools to support smart financial decisions",
    image: financeA,
    images: [financeA, financeB, financeC, financeD],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 2,
    title: "Movie Streaming Web App",
    // date: "May 2024",
    description:
      "Movie Streaming is a web-based movie and series streaming platform designed with an elegant Netflix-inspired UI. The app allows users to browse various categories, add titles to their personal watchlist, and watch trailers or featured content easily",
    image: streamA,
    images: [streamA, streamB, streamC, streamD],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://stream-movie-apps.netlify.app/",
  },
  {
    id: 1,
    title: "Inventory Management",
    // date: "",
    description:
      "A web-based inventory management application designed to optimize product tracking, stock control, supplier management, and order monitoring. This system helps businesses streamline operations by visualizing stock movement and generating real-time reports.",
    image: invenA,
    images: [invenA, invenB, invenC, invenD],
    tags: ["React Js", "Typescript", "HTML", "CSS"],
    category: "web app",
    webapp: "https://inventory-pro-app.netlify.app/",
  },
];
export const TimeLineData = [
  {
    year: 2017,
    text: "Started my journey",
  },
  {
    year: 2018,
    text: "Worked as a freelance developer",
  },
  {
    year: 2019,
    text: "Founded JavaScript Mastery",
  },
  {
    year: 2020,
    text: "Shared my projects with the world",
  },
  {
    year: 2021,
    text: "Started my own platform",
  },
];
